import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Logger from '../../../../../../ui-kitchen/src/utils/logger';
import { fetchVenuesForCollection } from '../../../../../../ui-kitchen/src/reducers';
import VenueList from '../../VenueList';
import DeltaWifiBookNow from '../DeltaWifiBookNow';
import { ALL_DAY } from '../../../../../../ui-kitchen/src/constants/resyCore';
import { AMEX_UTM_SOURCE, AMEX_DELTA_UTM_MEDIUM, AMEX_DELTA_UTM_BOOKING_CAMPAIGN } from '../../AmexMarketingUtils/constants';
import './DeltaWifiGDAVenues.scss';

const GDA_TYPE_ID = 10;

class DeltaWifiGDAVenues extends React.Component {
  static propTypes = {
    $rootScope: PropTypes.shape({
      $broadcast: PropTypes.func.isRequired,
      $on: PropTypes.func.isRequired,
      matchMedia: PropTypes.shape({
        xs: PropTypes.bool,
        sm: PropTypes.bool,
        md: PropTypes.bool,
        lg: PropTypes.bool,
        xl: PropTypes.bool,
      }).isRequired,
    }).isRequired,
    Analytics: PropTypes.shape({
      event: PropTypes.func.isRequired,
    }).isRequired,
    collectionList: PropTypes.arrayOf(PropTypes.object),
    loadNotifyModal: PropTypes.func.isRequired,
    cityCode: PropTypes.string,
    selectedDate: PropTypes.string,
    selectedTime: PropTypes.string,
    selectedSeats: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    showSeeMore: PropTypes.bool,
    venues: PropTypes.shape(PropTypes.object.isRequired).isRequired,
    isAuthenticated: PropTypes.bool,
    cityName: PropTypes.string.isRequired,
    citySlug: PropTypes.string.isRequired,
    isMobile: PropTypes.bool.isRequired,
    locationCode: PropTypes.string.isRequired,
    bookNowConfig: PropTypes.shape({
      name: PropTypes.string,
      no_venues_text: PropTypes.string,
      market: PropTypes.shape({
        api_limit: PropTypes.number,
        grid_limit: PropTypes.number,
        title: PropTypes.string,
      }),
      agnostic: PropTypes.shape({
        api_limit: PropTypes.number,
        grid_limit: PropTypes.number,
        title: PropTypes.string,
      }),
    }).isRequired,
    isAgnostic: PropTypes.bool.isRequired,
    latLng: PropTypes.shape({
      value: PropTypes.string,
    }),
    event: PropTypes.func.isRequired,
    userIsGda: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      xl: PropTypes.bool,
    }).isRequired,
    showAuthModal: PropTypes.func.isRequired,
  }

  static defaultProps = {
    cityCode: 'ny',
    selectedDate: null,
    selectedSeats: 2,
    selectedTime: '',
    showSeeMore: true,
    collectionList: [],
    isAuthenticated: false,
    latLng: undefined,
    userIsGda: false,
  }

  componentDidMount() {
    const { collectionList } = this.props;
    if (collectionList.length > 0) {
      this.getData();
    }
  }

  componentDidUpdate(pProps) {
    const {
      collectionList, cityCode, selectedDate, selectedSeats, isAuthenticated, selectedTime,
    } = this.props;

    if (collectionList.length > 0) {
      if (pProps.collectionList.length === 0) {
        this.getData();
      } else if (cityCode !== pProps.cityCode) {
        this.getData();
      } else if (selectedDate !== pProps.selectedDate) {
        this.getData();
      } else if (selectedSeats !== pProps.selectedSeats) {
        this.getData();
      } else if (selectedTime !== pProps.selectedTime) {
        this.getData();
      } else if (isAuthenticated !== pProps.isAuthenticated) {
        this.getData();
      }
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  getData = async () => {
    this.fetchVenues();
  }

  parseCollections = () => {
    const {
      collectionList,
    } = this.props;

    const collection = collectionList.filter((val) => val.info.type_id === GDA_TYPE_ID);
    if (collection.length > 0) return collection[0];

    return null;
  }

  fetchVenues = async () => {
    const {
      cityCode,
      selectedDate,
      selectedSeats,
      selectedTime,
      isAuthenticated,
      venues,
      bookNowConfig,
      dispatch,
    } = this.props;

    const collection = this.parseCollections();

    if (!collection) {
      return;
    }

    const { id: collectionId } = collection;

    const apiLimit = bookNowConfig.market.api_limit;

    const payload = {
      location_id: cityCode,
      collection_id: collectionId,
      day: selectedDate,
      party_size: selectedSeats,
      time_filter: selectedTime === ALL_DAY ? undefined : moment(selectedTime, 'HHmm').format('HH:mm'),
      limit: apiLimit,
      offset: 1,
      finder: 4,
      isAuth: isAuthenticated,
    };

    const key = `${cityCode}-${collectionId}-${selectedDate}-${selectedSeats}-${isAuthenticated}`;
    const venuesById = venues[key];

    if (!venuesById?.length) {
      try {
        await dispatch(fetchVenuesForCollection(payload));
      } catch (error) {
        Logger.error('[DeltaWifiGDAVenues] Error', error);
      }
    }
  }

  render() {
    const {
      $rootScope,
      loadNotifyModal,
      cityCode,
      selectedDate,
      selectedSeats,
      selectedTime,
      showSeeMore,
      Analytics,
      venues,
      isAuthenticated,
      cityName,
      isMobile,
      bookNowConfig,
      latLng,
      locationCode,
      isAgnostic,
      event,
      userIsGda,
      citySlug,
      matchMedia,
      showAuthModal,
    } = this.props;

    const collection = this.parseCollections();
    if (!collection) {
      return (
        <DeltaWifiBookNow
          cityName={cityName}
          cityCode={cityCode}
          citySlug={citySlug}
          selectedDate={selectedDate}
          selectedSeats={selectedSeats}
          selectedTime={selectedTime}
          isMobile={isMobile}
          latLng={latLng}
          loadNotifyModal={loadNotifyModal}
          locationCode={locationCode}
          $rootScope={$rootScope}
          isAuthenticated={isAuthenticated}
          bookNowConfig={bookNowConfig}
          isAgnostic={isAgnostic}
          event={event}
          matchMedia={$rootScope.matchMedia}
          analyticsEvent={event}
          showAuthModal={showAuthModal}
        />
      );
    }

    const {
      info: {
        name: title,
        description,
        image: badge,
      },
      id: collectionId,
    } = collection;

    const key = `${cityCode}-${collectionId}-${selectedDate}-${selectedSeats}-${isAuthenticated}`;
    const venuesById = venues[key];
    const hasNoVenueResults = !venuesById?.length;

    if (hasNoVenueResults) {
      return (
        <DeltaWifiBookNow
          cityName={cityName}
          cityCode={cityCode}
          citySlug={citySlug}
          selectedDate={selectedDate}
          selectedSeats={selectedSeats}
          selectedTime={selectedTime}
          isMobile={isMobile}
          latLng={latLng}
          loadNotifyModal={loadNotifyModal}
          locationCode={locationCode}
          $rootScope={$rootScope}
          isAuthenticated={isAuthenticated}
          bookNowConfig={bookNowConfig}
          isAgnostic={isAgnostic}
          event={event}
          matchMedia={$rootScope.matchMedia}
          analyticsEvent={event}
          showAuthModal={showAuthModal}
        />
      );
    }

    const { grid_limit: maxCards } = bookNowConfig?.market;

    let venuesLength = 0;
    if (maxCards < venuesById?.length) {
      venuesLength = maxCards;
    } else {
      venuesLength = venuesById?.length;
    }

    const tagBooking = {
      utm: {
        utm_source: AMEX_UTM_SOURCE,
        utm_medium: AMEX_DELTA_UTM_MEDIUM,
        utm_campaign: AMEX_DELTA_UTM_BOOKING_CAMPAIGN,
      },
    };

    return (
      <div className="DeltaWifiGDAVenues">
        <div className="DeltaWifiGDAVenues__venues">
          { !hasNoVenueResults && (
            <VenueList
              $rootScope={$rootScope}
              badge={badge}
              name={title}
              description={description}
              loadNotifyModal={loadNotifyModal}
              locationCode={cityCode}
              restaurants={venuesById}
              selectedDate={selectedDate}
              selectedSeats={selectedSeats}
              event={Analytics.event}
              hasNoResults={hasNoVenueResults}
              showSeeMore={showSeeMore}
              maxCards={maxCards}
              listId={collectionId}
              isGda
              userIsGda={userIsGda}
              deltaWifiVenuelength={venuesLength}
              isDeltaWifi
              tagBooking={tagBooking}
              matchMedia={matchMedia}
              isMobile={isMobile}
              showCarouselButtons={venuesById.length > maxCards}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  venues: state.collections.venues.other,
});

DeltaWifiGDAVenues.displayName = 'DeltaWifiGDAVenues';
export { DeltaWifiGDAVenues as ComponentDeltaWifiGDAVenuesUnderTest };
export default connect(mapStateToProps)(DeltaWifiGDAVenues);
